import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import DonateJSON from "./Version.json";
import {
  getAllVersions,
  addAppVersion,
  updateAppVersion,
} from "../../redux/slices/QuestionSlice";
import Table from "../../components/Atoms/Tables";
import GlobalSearchFilter from "../../components/Atoms/Global search/GlobalSearch";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import TableSkeletonLoader from "../../components/Loader/TableSkeletonLoader";
import moment from "moment-timezone";

// import toast from "react-hot-toast";
import ModalDefault from "../../components/ModalReport/Modal";
import { showErrorToast, showSuccessToast } from "../../components/Toast/Toast";

const Versions = () => {
  const size = 10;
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.question);
  const getAllVersionsData = selector?.getAllVersionsData;
  const loading = selector?.loading;

  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [errorCreate, setErrorCreate] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const platformOptions = ["ios", "android", "both"];
  const UpdateTypeOptions = ["Mandatory", "Optional"];

  // Create refs for select elements
  const platformRef = useRef(null);
  const UpdateTypeRef = useRef(null);
  useEffect(() => {
    fetchVersions();
  }, [searchKeyword, page]);

  const fetchVersions = () => {
    const reqData = {
      keyWord: searchKeyword,
      pageNo: page,
      size: size,
    };
    dispatch(getAllVersions(reqData));
  };

  const handleSearch = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrorCreate({ ...errorCreate, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Step 1: Manual Validation
    const newErrors = {};
    const requiredFields = [
      "platform",
      "version",
      "buildUrl",
      "UpdateType",
      "featuresUpdate",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = `${
          field === "buildUrl" ? "Build URL" : field
        } is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrorCreate(newErrors);
      return;
    }

    // Step 2: Prepare payload
    const payload = {
      platform: formData.platform?.trim() || "",
      version: formData.version?.trim() || "",
      buildUrl: formData.buildUrl?.trim() || "",
      updateType: formData.UpdateType?.trim().toLowerCase() || "",
      changelog: formData.changelog?.trim() || "",
    };

    try {
      let response;

      if (isEditMode) {
        payload.id = formData._id;
        payload.isActive = formData.isActive;
        response = await dispatch(updateAppVersion(payload)).unwrap();
      } else {
        response = await dispatch(addAppVersion(payload)).unwrap();
      }

      // Step 3: Check backend response
      if (response?.error === true) {
        setIsOpen(false);
        throw new Error(response?.message || "Something went wrong!");
      }

      showSuccessToast(
        isEditMode
          ? "Version updated successfully"
          : "Version added successfully"
      );
      setIsOpen(false);
      fetchVersions();
    } catch (error) {
      console.error("Submission Error:", error);
      showErrorToast(error);
    }
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setFormData({});
    setErrorCreate({});
    setIsOpen(true);
  };

  // const handleEdit = (rowData) => {
  //   setIsEditMode(true);
  //   setFormData(rowData);
  //   setIsOpen(true);
  // };

  const headers = {
    // platform: "Platform",
    version: "App Version",
    // updateType: "Update Type",
    changelog: "Features Update",
    buildUrl: "Build URL",
    releaseDate: "Release Date",

    // actions: "Actions",
  };

  const rows = getAllVersionsData?.data?.versions?.map((ele) => ({
    ...ele,
    releaseDate: moment(ele?.releaseDate).format("DD-MM-YYYY"),
    // isActive: (
    //   <span
    //     className={`px-2 py-1 rounded text-xs font-medium ${
    //       ele?.isActive
    //         ? "bg-green-100 text-green-800"
    //         : "bg-red-100 text-red-800"
    //     }`}
    //   >
    //     {ele?.isActive ? "Active" : "Inactive"}
    //   </span>
    // ),
    // actions: (
    //   <div className="flex gap-2">
    //     <FiEdit
    //       className="text-blue-500 cursor-pointer"
    //       onClick={() => handleEdit(ele)}
    //     />
    //   </div>
    // ),
  }));

  return (
    <>
      <div className="p-4 md:px-8 overflow-y-auto">
        <GlobalSearchFilter
          showExportButton={false}
          title={DonateJSON.Heading}
          searchKeyword={searchKeyword}
          onSearchChange={handleSearch}
          showAddButton={true}
          buttonLabel="Add Version"
          onAddClick={handleAdd}
          placeholder="Search by Feature Update"
        />
        {loading ? (
          <TableSkeletonLoader rows={5} columns={5} />
        ) : (
          <Table headers={headers} list={rows} size={size} pageNo={page} />
        )}
        {(getAllVersionsData?.data?.pagination?.totalCount || 0) > size && (
          <div className="flex justify-end mt-6">
            <ReactPaginate
              previousLabel={<FiChevronLeft className="h-5 w-5" />}
              nextLabel={<FiChevronRight className="h-5 w-5" />}
              breakLabel={"..."}
              pageCount={Math.ceil(
                (getAllVersionsData?.data?.pagination?.totalCount || 0) / size
              )}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"flex items-center gap-1"}
              pageClassName={"px-3 py-1 rounded-md border border-gray-300"}
              pageLinkClassName={"text-sm font-medium"}
              activeClassName={"bg-blue-500 text-white border-blue-500"}
              previousClassName={"p-1 rounded-md border border-gray-300"}
              nextClassName={"p-1 rounded-md border border-gray-300"}
              disabledClassName={"opacity-50 cursor-not-allowed"}
            />
          </div>
        )}
      </div>

      <ModalDefault
        isOpen={isOpen}
        title={isEditMode ? "Edit Version" : "Add Version"}
        closeModal={() => {
          setIsOpen(false);
          setFormData({});
          setErrorCreate({});
        }}
      >
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="platform"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Platform
            </label>
            <select
              id="platform"
              name="platform"
              value={formData.platform}
              onChange={handleChange}
              ref={platformRef}
              className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            >
              <option value="">Select Platform</option>
              {platformOptions.map((option) => (
                <option key={option} value={option}>
                  {option.charAt(0).toUpperCase() + option.slice(1)}
                </option>
              ))}
            </select>
            {errorCreate?.platform && (
              <div className="text-sm text-red-500">{errorCreate.platform}</div>
            )}
          </div>
          <div className="mb-4">
            <label
              htmlFor="UpdateType"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              UpdateType
            </label>
            <select
              id="UpdateType"
              name="UpdateType"
              value={formData.UpdateType}
              onChange={handleChange}
              ref={UpdateTypeRef}
              className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            >
              <option value="">Select UpdateType</option>
              {UpdateTypeOptions.map((option) => (
                <option key={option} value={option}>
                  {option.charAt(0).toUpperCase() + option.slice(1)}
                </option>
              ))}
            </select>
            {errorCreate?.UpdateType && (
              <div className="text-sm text-red-500">
                {errorCreate.UpdateType}
              </div>
            )}
          </div>
          {["version", "buildUrl", "featuresUpdate"].map((field, idx) => (
            <div className="mb-4" key={idx}>
              <label
                htmlFor={field}
                className="block text-sm font-medium text-gray-700 mb-1 capitalize"
              >
                {field === "buildUrl" ? "Build URL" : field}
              </label>
              <input
                type="text"
                id={field}
                name={field}
                value={formData[field] || ""}
                onChange={handleChange}
                className="border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:border-blue-500"
                placeholder={`Enter ${field}`}
              />
              {errorCreate?.[field] && (
                <div className="text-sm text-red-500">{errorCreate[field]}</div>
              )}
            </div>
          ))}
          <button
            type="submit"
            className="bg-blue-500 w-full text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
          >
            {isEditMode ? "Update" : "Submit"}
          </button>
        </form>
      </ModalDefault>
    </>
  );
};

export default Versions;
